export function precio(importe) {
  return `${parseFloat(importe).toLocaleString('es', { maximumFractionDigits: 2 })} €`;
}

export function porcentaje(porc) {
  return `${parseFloat(porc).toLocaleString('es', { maximumFractionDigits: 0 })} %`;
}

/**
 * Devuelve true si es una variable numérica o si es un string que se puede convertir a numérico.
 * '', '   ', undefined etc lo toma como no válido
 * https://stackoverflow.com/a/58550111
 * @param {*} num
 */
export function esNumeroValido(num) {
  return (typeof (num) === 'number' || (typeof (num) === 'string' && num.trim() !== '')) && !Number.isNaN(num);
}
